// What each setup card's confirm button did (v3 `useSetupDrafts.ts`), keyed by `draft_ref`: a card
// keeps its saved / failed / discarded state when the thread is switched away and back, in the main
// chat and in a feature-chat panel alike. Not persisted — a reload reads the status the history
// stamps on each card instead (`storedDraftState`).
import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { DraftConfirmFailure } from '../service/orpheusDraftConfirm'

export type DraftStatus = 'confirming' | 'saved' | 'failed' | 'discarded'

export interface DraftState {
  status: DraftStatus
  result: Record<string, unknown> | null
  failure: DraftConfirmFailure | null
}

export const useOrpheusSetupDraftStore = defineStore('orpheusSetupDraftStore', () => {
  const drafts = ref<Record<string, DraftState>>({})

  function get(draftRef: string | null | undefined): DraftState | null {
    return draftRef ? (drafts.value[draftRef] ?? null) : null
  }

  function set(draftRef: string, state: DraftState): void {
    drafts.value = { ...drafts.value, [draftRef]: state }
  }

  function reset(): void {
    drafts.value = {}
  }

  return { drafts, get, set, reset }
})
